module.exports = __webpack_public_path__ + "static/media/retargeting.8617e376.svg";